export const supportedLanguages = {
  English: {
    shortCodeName: 'en',
    largeCodeName: 'en-us',
    userFriendlyName: 'English (US)',
    flagImageRoot: '/img/flags/en.png'
  },
  Spanish: {
    shortCodeName: 'es',
    largeCodeName: 'es-mx',
    userFriendlyName: 'Español (MX)',
    flagImageRoot: '/img/flags/mx.png'
  }
} as const

export const supportedLanguagesList = Object.values(supportedLanguages)
export const defaultContentLanguage = supportedLanguages.English
export const supportedLanguagesLargeCodeNames: SupportedLanguage['largeCodeName'][] = supportedLanguagesList.map(
  ({ largeCodeName }) => largeCodeName
)
export const supportedLanguagesShortCodeNames: SupportedLanguage['shortCodeName'][] = supportedLanguagesList.map(
  ({ shortCodeName }) => shortCodeName
)
export type SupportedLanguage = (typeof supportedLanguages)[Keys]

type Keys = keyof typeof supportedLanguages

export const i18nOptions = {
  // This is the list of languages your application supports
  supportedLngs: supportedLanguagesShortCodeNames,
  // This is the language you want to use in case
  // if the user language is not in the supported languages list
  fallbackLng: supportedLanguages.English.shortCodeName,
  // The default namespace of i18next is "translation", but you can customize it here
  defaultNS: 'common',
  // Disabling suspense is recommended
  react: { useSuspense: false }
}
